/**
 * 素材库：图片 / 视频 / 其它文件的上传、预览、复制地址、删除
 */
<template>
  <div class="mp">
    <div class="mp-head">
      <h2 class="mp-title">素材库</h2>
      <div class="mp-ops">
        <el-radio-group v-model="type" size="small" @change="loadList">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="image">图片</el-radio-button>
          <el-radio-button label="video">视频</el-radio-button>
          <el-radio-button label="file">其它</el-radio-button>
        </el-radio-group>
        <el-button size="small" type="primary" @click="pick">上传素材</el-button>
      </div>
    </div>

    <div class="mp-grid" v-loading="loading">
      <div class="mp-item" v-for="m in list" :key="m.url">
        <div class="mp-preview">
          <img v-if="m.type === 'image'" :src="m.url" alt="" />
          <video v-else-if="m.type === 'video'" :src="m.url" muted preload="metadata"></video>
          <span v-else class="mp-file">{{ ext(m.name) }}</span>
        </div>
        <div class="mp-meta">
          <p class="mp-name" :title="m.name">{{ m.name }}</p>
          <p class="mp-sub">{{ sizeText(m.size) }} · {{ timeText(m.updatedAt) }}</p>
        </div>
        <div class="mp-btns">
          <el-button size="mini" type="text" @click="copy(m)">复制地址</el-button>
          <el-button size="mini" type="text" @click="preview(m)">预览</el-button>
          <el-button size="mini" type="text" style="color:#ff7a6b" @click="remove(m)">删除</el-button>
        </div>
      </div>
      <p v-if="!loading && !list.length" class="mp-empty">暂无素材，点击右上角「上传素材」</p>
    </div>

    <input ref="file" type="file" hidden multiple
      accept="image/*,video/*,.pdf,.zip,.json,.csv,.xls,.xlsx"
      @change="onFiles" />

    <el-dialog :visible.sync="previewVisible" title="预览" width="900px" append-to-body>
      <div class="mp-preview-big">
        <img v-if="previewItem && previewItem.type === 'image'" :src="previewItem.url" alt="" />
        <video v-else-if="previewItem" :src="previewItem.url" controls autoplay style="width:100%"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/cms/api'
import { mediaUrl } from '@/cms/config'

export default {
  name: 'CmsMediaPanel',
  data() {
    return {
      type: '',
      list: [],
      loading: false,
      previewVisible: false,
      previewItem: null,
    }
  },
  created() { this.loadList() },
  methods: {
    loadList() {
      this.loading = true
      api.mediaList(this.type)
        .then(list => {
          this.list = list.map(m => Object.assign({}, m, { url: mediaUrl(m.url) }))
        })
        .catch(e => this.$message.error(e.message || '素材列表加载失败'))
        .then(() => { this.loading = false })
    },
    pick() { this.$refs.file.click() },
    onFiles(e) {
      const files = Array.from(e.target.files || [])
      if (!files.length) return
      let done = 0
      const loading = this.$loading({ text: `上传中 0/${files.length}`, background: 'rgba(0,0,0,.5)' })
      const next = () => {
        done++
        loading.text = `上传中 ${done}/${files.length}`
        if (done >= files.length) {
          loading.close()
          e.target.value = ''
          this.loadList()
          this.$message.success(`已上传 ${files.length} 个素材`)
        }
      }
      files.forEach(f => {
        api.uploadMedia(f)
          .catch(err => this.$message.error(`${f.name}：${err.message || '上传失败'}`))
          .then(next)
      })
    },
    ext(name) { return String(name).split('.').pop().toUpperCase() },
    sizeText(b) {
      if (!b) return '0 B'
      const u = ['B', 'KB', 'MB', 'GB']
      let i = 0
      let v = b
      while (v >= 1024 && i < u.length - 1) { v /= 1024; i++ }
      return v.toFixed(i ? 1 : 0) + ' ' + u[i]
    },
    timeText(t) {
      if (!t) return ''
      return String(t).replace('T', ' ').slice(0, 19)
    },
    copy(m) {
      const url = window.location.origin + m.url
      const ta = document.createElement('textarea')
      ta.value = url
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制素材地址')
      } catch (e) {
        this.$message.info(url)
      }
      document.body.removeChild(ta)
    },
    preview(m) { this.previewItem = m; this.previewVisible = true },
    remove(m) {
      this.$confirm('删除后已引用该素材的页面将回落为默认素材，确认删除？', '提示', { type: 'warning' })
        .then(() => api.removeMedia(m.name))
        .then(() => { this.$message.success('已删除'); this.loadList() })
        .catch(() => { /* 取消或失败均忽略 */ })
    },
  },
}
</script>

<style lang="less" scoped>
.mp { color: #d8e8ff; }
.mp-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.mp-title { margin: 0; font-size: 16px; color: #eaf3ff; }
.mp-ops { display: flex; align-items: center; gap: 12px; }
.mp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)); gap: 14px; min-height: 200px; }
.mp-item { border: 1px solid rgba(80, 150, 240, .22); border-radius: 10px; overflow: hidden; background: rgba(13, 32, 64, .5); transition: border-color .2s, transform .2s; }
.mp-item:hover { border-color: #31ffff; transform: translateY(-2px); }
.mp-preview { height: 120px; background: #08152c; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.mp-preview img, .mp-preview video { width: 100%; height: 100%; object-fit: cover; }
.mp-file { font-size: 13px; color: #9fc0e8; letter-spacing: 1px; }
.mp-meta { padding: 8px 10px 4px; }
.mp-name { margin: 0 0 4px; font-size: 11px; color: #eaf3ff; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mp-sub { margin: 0; font-size: 11px; color: #6f8bb5; }
.mp-btns { display: flex; justify-content: space-between; padding: 0 8px 6px; }
.mp-empty { grid-column: 1 / -1; text-align: center; padding: 60px 0; color: #6f8bb5; }
.mp-preview-big img { width: 100%; }
</style>
